// Icon Sizes
export const ICON_SIZE_6 = "6";
export const ICON_SIZE_8 = "8";
export const ICON_SIZE_10 = "10";
export const ICON_SIZE_12 = "12";
export const ICON_SIZE_24 = "24";
